import * as React from "react"
import {Box} from "@mui/material";
import {AppLink} from "@ui-seeker/app"
import {FlagsIconSeeker, IconSeeker} from "@ui-seeker/core"


export default function LabelCountry({ country, label, url=null, sx={} }) {

    if (!url) return <LabelCountryLinkless country={country} label={label} sx={sx} />

    return <AppLink to={url} target="_blank">
        <LabelCountryLinkless country={country} label={label} sx={sx} showIcon />
    </AppLink>
}

const LabelCountryLinkless = ({ country, label, sx, showIcon=false }) => <>
    <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: .5, ...sx }}>
        <FlagsIconSeeker countryName={country} />
        <Box component="span">
            {label}
        </Box>
        {showIcon && <IconSeeker icon={'up-right-from-square'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>}
    </Box>
</>